// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import { useHistory } from 'react-router';
import { interactiveScale } from 'utilities/FramerAnimations';
import './Button.module.scss';
// =========================
type Color =
  | 'blue'
  | 'white'
  | 'grey'
  | 'green'
  | 'red'
  | 'white-red'
  | 'transparent-white-border'
  | 'white-border'
  | 'transparent-white-border-purple'
  | 'white-border-purple'
  | 'double-grey'
  | 'grey-black'
  | 'inactive'
  | 'purple-light'
  | 'purple';

type Props = {
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  to?: string;
  color?: Color;
  children: React.ReactNode;
  inactive?: boolean;
  selected?: boolean;
};

export default function Button({
  color = 'blue',
  children,
  onClick,
  to,
  inactive,
  selected,
}: Props) {
  const history = useHistory();

  return (
    <motion.button
      onClick={
        to
          ? (e) => {
              e.stopPropagation();
              history.push(to);
            }
          : onClick
      }
      type={to ? 'button' : 'submit'}
      styleName={`Button ${color}`}
      style={
        inactive
          ? {
              pointerEvents: 'none',
              opacity: 0.5,
            }
          : {}
      }
      {...interactiveScale}
    >
      {children}
    </motion.button>
  );
}
